import {NgModule} from '@angular/core';
import {RouterModule, RouterOutlet} from "@angular/router";
import {AngularModule} from "@modules/angular.module";
import {MaterialModule} from "@modules/material.module";

import {ConfirmRemoveComponent} from "@shared-components/confirm-remove/confirm-remove.component";
import {ConfirmationDialogComponent} from '@shared-components/confirmation-dialog/confirmation-dialog.component';
import {CsvImportComponent} from "@shared-components/csv-import/csv-import.component";
import {CustomRangeSelectorComponent} from "@shared-components/custom-range-selector/custom-range-selector.component";
import {
  CustomTimeRangePickerComponent
} from '@shared-components/custom-time-range-picker/custom-time-range-picker.component';
import {ErrorPopupComponent} from '@shared-components/dialogs/error-popup/error-popup.component';
import {IconPopupComponent} from '@shared-components/dialogs/icon-popup/icon-popup.component';
import {InfoPanelComponent} from "@shared-components/info-panel/info-panel.component";

import {PreAuthToolbarComponent} from "@shared-components/pre-auth-toolbar/pre-auth-toolbar.component";
import {ResponsiveDrawerComponent} from '@shared-components/responsive-drawer/responsive-drawer.component';
import {StyledComponentsComponent} from "@shared-components/styled-components/styled-components.component";
import {TimelineComponent} from "@shared-components/timeline/timeline.component";
import {EmailEditorModule} from "angular-email-editor";
import {GridsterModule} from "angular-gridster2";
import {NgOtpInputModule} from "ng-otp-input";
import {NgChartsModule} from "ng2-charts";
import {NgxEditorModule} from "ngx-editor";
import {ImageCropperModule} from "ngx-image-cropper";


const components = [
  ConfirmationDialogComponent,
  CustomRangeSelectorComponent,
  CustomTimeRangePickerComponent,
  ErrorPopupComponent,
  IconPopupComponent,
  InfoPanelComponent,
  PreAuthToolbarComponent,
  ResponsiveDrawerComponent,
  StyledComponentsComponent,
  TimelineComponent
]

const modules = [
  NgOtpInputModule,
  NgChartsModule,
  ImageCropperModule,
  GridsterModule,
  RouterOutlet,
  RouterModule,
  EmailEditorModule,
  NgxEditorModule
]

@NgModule({
  declarations: [
    ...components
  ],
  imports: [
    CsvImportComponent,
    ConfirmRemoveComponent,
    ...modules,
    MaterialModule,
    AngularModule
  ],
  exports: [
    ...components,
    ...modules,
    CsvImportComponent,
    ConfirmRemoveComponent
  ]
})
export class AppSharedModule { }
